module.exports = __webpack_public_path__ + "img/browse-vehicles-search-hero-kia.a51a6072.png";